import { Box, Text } from '@chakra-ui/react';
import { type User } from '@halo/chat-sdk';
import { RippleEffect, UserItem } from '@halo/ui-chat-react';
import { groupContactsByFirstLetter, sortGroupedContacts } from './helpers';

interface ContactListProps {
  contacts: User[];
  onAvatarClick?: (contact: User) => Promise<void>;
  onClick?: (contact: User) => void;
}

function ContactList({ contacts, onAvatarClick, onClick }: ContactListProps) {
  const groupedContacts = useMemo(
    () => sortGroupedContacts(groupContactsByFirstLetter(contacts)),
    [contacts]
  );
  // const flatContacts = useMemo(() => flatGroupedContacts(groupedContacts), [groupedContacts]);
  // const alphabet = useMemo(() => Object.keys(groupedContacts), [groupedContacts]);

  // const letterIndexMap = useMemo(() => {
  //   const map: { [key: string]: number } = {};
  //   flatContacts.forEach((item, index) => {
  //     if (item.isGroupKey) {
  //       map[item.name] = index;
  //     }
  //   });
  //   return map;
  // }, [flatContacts]);

  return (
    <Box className="ContactList scrollHover" h="full" overflowY="auto">
      {Object.keys(groupedContacts).map((letter) => (
        <Box key={letter}>
          <Text px="2" py="2" fontSize="sm" fontWeight="semibold" lineHeight="normal" color="fg">
            {letter}
          </Text>
          <Box>
            {groupedContacts[letter].map((contact) => (
              <RippleEffect key={contact.user_id}>
                <UserItem
                  key={contact.user_id}
                  {...contact}
                  onlyFinalName={false}
                  error={!(contact.have_group_key && contact.have_user_key)}
                  onAvatarClick={() => onAvatarClick?.(contact)}
                  onClick={() => onClick?.(contact)}
                  cursor="pointer"
                />
              </RippleEffect>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

const MemoizedContactList = memo(ContactList);

export { MemoizedContactList as ContactList };
